import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import html2canvas from 'html2canvas';
import { API_BASE_URL } from '../config/api';
import './CalendarProductie.css';

const CalendarProductie = ({ planificare = [], setPlanificare }) => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [viewMode, setViewMode] = useState('week'); // 'month', 'week', 'day'
  const [productions, setProductions] = useState([]); // planificari productie
  const [statii, setStatii] = useState([]); // program stații
  const [produse, setProduse] = useState([]);
  const [clienti, setClienti] = useState([]);
  const [preforme, setPreforme] = useState([]);
  const [operatori, setOperatori] = useState([]);
  const [mecanici, setMecanici] = useState([]);
  const [saciTypes, setSaciTypes] = useState([]);
  const [materialeModal, setMaterialeModal] = useState(null); // ISO date string or null
  const [materialeForm, setMaterialeForm] = useState({ scotch: '', hartie: '', saci: {} });
  const [materialeData, setMaterialeData] = useState({}); // cache: { [date]: {scotch, hartie, saci} }
  const [tureMeta, setTureMeta] = useState([]);
  const [selectedTureFilters, setSelectedTureFilters] = useState([]); // array of tura names; empty = all
  const [tureDropdownOpen, setTureDropdownOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [selectedProd, setSelectedProd] = useState(null);
  const [editForm, setEditForm] = useState({ nrSaci: '', nrBuc: '', status: '', nrLot: '', mecanicId: '', operatorId: '', rebuturiOperator: '', rebuturiCuptor: '', rebuturiMasinaSuflat: '', rebuturiReglaje: '', rebuturiSefTura: '', rebuturiPreforma: '' });
  const [selectedCreateSlot, setSelectedCreateSlot] = useState(null);
  const [createForm, setCreateForm] = useState({
    produsId: '',
    preformaId: '',
    operatorId: '',
    clientId: '',
    nrSaci: '',
    nrBuc: '',
    dataLivrare: '',
    startTime: '',
    endTime: '',
    status: 'În desfășurare',
    observatii: ''
  });
  const calendarRef = useRef(null);
  const todayISO = new Date().toISOString().slice(0, 10);
  const [reportDate, setReportDate] = useState(todayISO);

  const today = new Date();

  // Helperi dată/format
  const monthNames = ['Ianuarie','Februarie','Martie','Aprilie','Mai','Iunie','Iulie','August','Septembrie','Octombrie','Noiembrie','Decembrie'];
  const dayNames = ['Duminică','Luni','Marți','Miercuri','Joi','Vineri','Sâmbătă'];
  const shortDayNames = ['Lun','Mar','Mie','Joi','Vin','Sâm','Dum'];
  const getMonthName = d => monthNames[d.getMonth()] || '';
  const getDayName = d => dayNames[d.getDay()] || '';
  const statusSlug = s => {
    switch ((s || '').toLowerCase()) {
      case 'în desfășurare': return 'in-desfasurare';
      case 'finalizat': return 'finalizat';
      default: return (s || '').toLowerCase().replace(/\s+/g, '-');
    }
  };
  const getShortDayName = d => shortDayNames[(d.getDay()+6)%7] || ''; // repo folosește Luni ca prima
  const isSameDay = (a,b) => a && b && a.getFullYear()===b.getFullYear() && a.getMonth()===b.getMonth() && a.getDate()===b.getDate();
  const isSameMonth = (a,b) => a && b && a.getFullYear()===b.getFullYear() && a.getMonth()===b.getMonth();

  const toDateObj = (val) => {
    if(!val) return null;
    if (val instanceof Date) return val;
    let s = String(val).trim();
    if(!s) return null;
    // Acceptă formate: YYYY-MM-DD, YYYY-MM-DD HH:MM, YYYY-MM-DDTHH:MM, DD/MM/YYYY, DD.MM.YYYY
    let datePart='', timePart='00:00';
    if (s.includes('T')) { [datePart,timePart] = s.split('T'); timePart = timePart.slice(0,5); }
    else if (s.includes(' ')) { [datePart,timePart] = s.split(' '); timePart = timePart.slice(0,5); }
    else datePart = s;
    let year,month,day;
    if (/^\d{4}-\d{2}-\d{2}$/.test(datePart)) { const [y,m,d] = datePart.split('-'); year=+y; month=+m-1; day=+d; }
    else if (/^\d{2}[/.]\d{2}[/.]\d{4}$/.test(datePart)) { const parts = datePart.split(/[/.]/); day=+parts[0]; month=+parts[1]-1; year=+parts[2]; }
    else return null;
    if (isNaN(year)||isNaN(month)||isNaN(day)) return null;
    const [hh,mm] = timePart.split(':');
    return new Date(year,month,day, parseInt(hh||'0',10), parseInt(mm||'0',10));
  };

  const navigateMonth = (dir) => { setCurrentDate(d => new Date(d.getFullYear(), d.getMonth()+dir, 1)); };
  const navigateWeek = (dir) => { setCurrentDate(d => { const nd = new Date(d); nd.setDate(d.getDate()+dir*7); return nd; }); };
  const navigateDay = (dir) => { setCurrentDate(d => { const nd = new Date(d); nd.setDate(d.getDate()+dir); return nd; }); };
  const goToToday = () => setCurrentDate(new Date());

  // API_BASE_URL definit central

  // Construiește wrapper HTML (antet + conținut) folosit atât la PDF cât și la Print
  const buildExportWrapper = () => {
    const container = calendarRef.current;
    if (!container) throw new Error('Element calendar lipsă');
  // Folosim doar conținutul calendarului, evităm meniuri/alte secțiuni
  const originalContent = container.querySelector('.calendar-content');
  if (!originalContent) throw new Error('calendar-content lipsă');

    // Etichetă în funcție de mod
    let label;
    if (viewMode === 'month') {
      label = `Calendar lunar ${getMonthName(currentDate)} ${currentDate.getFullYear()}`;
    } else if (viewMode === 'week') {
      const temp = new Date(currentDate);
      const dow = temp.getDay(); const sub = dow === 0 ? 6 : dow - 1;
      const startOfWeek = new Date(temp); startOfWeek.setDate(temp.getDate()-sub);
      const endOfWeek = new Date(startOfWeek); endOfWeek.setDate(startOfWeek.getDate()+6);
      label = `Calendar săptămânal ${startOfWeek.getDate()} ${getMonthName(startOfWeek)} - ${endOfWeek.getDate()} ${getMonthName(endOfWeek)} ${endOfWeek.getFullYear()}`;
    } else {
      label = `Calendar zilnic ${currentDate.getDate()} ${getMonthName(currentDate)} ${currentDate.getFullYear()}`;
    }

    // Afișăm filtrele de ture selectate în antet (pentru claritate în export/print)
    const allShiftNames = (Array.isArray(tureMeta) ? tureMeta.map(t => (t && (t.name || t)) || '') : []).filter(Boolean);
    const hasFilters = selectedTureFilters && selectedTureFilters.length > 0;
    const allSelected = allShiftNames.length > 0 && allShiftNames.every(n => selectedTureFilters.includes(n));
    const shiftsLabel = (!hasFilters || allSelected) ? 'Toate' : selectedTureFilters.join(', ');

  const brandColor = '#252682';
  const wrapper = document.createElement('div');
    wrapper.style.padding = '16px 16px 24px 16px';
    wrapper.style.background = '#ffffff';
    wrapper.style.fontFamily = 'Arial, Roboto, "Segoe UI", sans-serif';
    wrapper.style.color = '#222';
    wrapper.style.width = originalContent.scrollWidth + 'px';
  wrapper.className = 'print-only';

    const header = document.createElement('div');
    header.style.display = 'flex';
    header.style.alignItems = 'center';
    header.style.marginBottom = '12px';

    const logo = document.createElement('img');
    logo.src = '/ykhome/logo-yk-cu-an.png';
    logo.style.height = '60px';
    logo.style.width = 'auto';
    logo.style.objectFit = 'contain';
    logo.style.marginRight = '18px';

    const titles = document.createElement('div');
    titles.innerHTML = `<div style="font-size:20px;font-weight:700;color:${brandColor};line-height:1.15;">Younger Karom Production Company</div>
      <div style="font-size:14px;font-weight:500;margin-top:3px;color:${brandColor};">Sistem de Planificare a Producției</div>
      <div style="font-size:12px;font-weight:600;margin-top:6px;">${label}</div>
      <div style="font-size:11px;margin-top:2px;color:#444">Ture: ${shiftsLabel}</div>`;
    header.appendChild(logo); header.appendChild(titles); wrapper.appendChild(header);

    const clone = originalContent.cloneNode(true);
    clone.classList.remove('exporting');
    wrapper.appendChild(clone);
    return { wrapper, clone };
  };

  const formatISODate = (d) => {
    return `${d.getFullYear()}-${(d.getMonth()+1).toString().padStart(2,'0')}-${d.getDate().toString().padStart(2,'0')}`;
  };

  const formatDateLabel = (value) => {
    const date = toDateObj(value);
    if (!date) return value || '';
    return `${getDayName(date)}, ${date.getDate()} ${getMonthName(date)} ${date.getFullYear()}`;
  };

  const [schimburi, setSchimburi] = useState([]);
  const loadSchimburi = () => {
    try { setSchimburi(JSON.parse(localStorage.getItem('schimburiMatrita') || '[]')); } catch { setSchimburi([]); }
  };

  // Sincronizează productions cu datele din props planificare
  useEffect(() => {
    if (Array.isArray(planificare)) {
      const mapped = planificare.map(p => {
        const start = toDateObj(p.dataStart || p.data_start);
        const end = toDateObj(p.dataTerminare || p.data_terminare || p.dataLivrare || p.data_livrare);
        return { ...p, _start: start, _end: end };
      }).filter(p => p._start && p._end);
      setProductions(mapped);
    }
  }, [planificare]);

  // Fetch planificari (backup dacă nu vine prin props)
  const fetchProductions = async () => {
    setLoading(true); setError('');
    try {
      const res = await axios.get(`${API_BASE_URL}/planificare-productie`);
      const list = Array.isArray(res.data) ? res.data : [];
      // Mapare cu date parse
      const mapped = list.map(p => {
        const start = toDateObj(p.dataStart || p.data_start);
        const end = toDateObj(p.dataTerminare || p.data_terminare || p.dataLivrare || p.data_livrare);
        return { ...p, _start: start, _end: end };
      }).filter(p=>p._start && p._end);
      setProductions(mapped);
      
      // Actualizează și state-ul principal dacă avem setPlanificare
      if (setPlanificare && typeof setPlanificare === 'function') {
        setPlanificare(list);
      }
    } catch (e) {
      setError('Eroare la încărcarea producției');
    } finally { setLoading(false); }
  };

  useEffect(()=>{ 
    // Dacă nu avem date prin props, încărcăm din API
    if (!planificare || planificare.length === 0) {
      fetchProductions(); 
    }
    fetchSupportData();
    fetchStatii(); 
    // Fetch shifts metadata
    axios.get(`${API_BASE_URL}/ture`).then(res=>{ setTureMeta(Array.isArray(res.data)?res.data:[]); }).catch(()=>{});
    loadSchimburi();
    const onStorage = (e) => { if (e.key === 'schimburiMatrita') loadSchimburi(); };
    const onCustom = () => loadSchimburi();
    window.addEventListener('storage', onStorage);
    window.addEventListener('schimb-matrita-updated', onCustom);
    return () => { window.removeEventListener('storage', onStorage); window.removeEventListener('schimb-matrita-updated', onCustom); };
  }, []);

  const fetchStatii = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/statii-lucru`);
      setStatii(Array.isArray(res.data)?res.data:[]);
    } catch(e) { /* ignorăm, folosim fallback */ }
  };

  const fetchSupportData = async () => {
    try {
      const [produseRes, clientiRes, preformeRes, operatoriRes, mecaniciRes, saciRes] = await Promise.all([
        axios.get(`${API_BASE_URL}/produse`),
        axios.get(`${API_BASE_URL}/clienti`),
        axios.get(`${API_BASE_URL}/preforme`),
        axios.get(`${API_BASE_URL}/operatori`),
        axios.get(`${API_BASE_URL}/mecanici`),
        axios.get(`${API_BASE_URL}/saci`)
      ]);
      setProduse(Array.isArray(produseRes.data) ? produseRes.data : []);
      setClienti(Array.isArray(clientiRes.data) ? clientiRes.data : []);
      setPreforme(Array.isArray(preformeRes.data) ? preformeRes.data : []);
      setOperatori(Array.isArray(operatoriRes.data) ? operatoriRes.data : []);
      setMecanici(Array.isArray(mecaniciRes.data) ? mecaniciRes.data : []);
      setSaciTypes(Array.isArray(saciRes.data) ? saciRes.data : []);
    } catch (e) {
      console.error('Eroare la încărcarea datelor pentru creare planificare din calendar:', e);
    }
  };

  const getStatieForEvent = (ev) => {
    const id = ev.statie_id || ev.statieId; if (!id) return null;
    return statii.find(s=>s.id===id) || null;
  };

  // Returnează o culoare în funcție de tura evenimentului (din meta ture sau din stație)
  const getEventShiftColor = (ev) => {
    const evTura = (ev.tura || ev.tura_name || ev.turaName) || (getStatieForEvent(ev) && getStatieForEvent(ev).tura) || '';
    if (!evTura) return undefined;
    const meta = (tureMeta || []).find(t => (t.name || t) === evTura);
    return meta && meta.color ? meta.color : undefined;
  };

  const eventMatchesSelectedTure = (ev) => {
    // If no shifts are selected we show everything (no filter)
    if (!selectedTureFilters || selectedTureFilters.length === 0) return true;
    // Determine event tura: prefer explicit field on event, fallback to station.tura
    const evTura = (ev.tura || ev.tura_name || ev.turaName) || (getStatieForEvent(ev) && getStatieForEvent(ev).tura) || '';
    if (!evTura) return false; // if no tura info, don't show
    return selectedTureFilters.includes(evTura);
  };

  const parseHM = (str, def) => {
    if (!str || !/^\d{1,2}:\d{2}$/.test(str)) return def;
    const [h,m]=str.split(':').map(Number); return h*60+m;
  };

  // Funcții helper pentru calculul zilelor de lucru
  const getDayKey = (date) => {
    return ['Dum','Lun','Mar','Mie','Joi','Vin','Sam'][date.getDay()];
  };

  const isWorkingDay = (date, workingDays) => {
    if (!workingDays || workingDays.length === 0) {
      // Default: Luni-Vineri dacă nu e specificat
      workingDays = ['Lun','Mar','Mie','Joi','Vin'];
    }
    const dayKey = getDayKey(date);
    return workingDays.includes(dayKey);
  };

  const isStationWorkingOnDay = (station, date) => {
    const workingDays = station.workingDays || ['Lun','Mar','Mie','Joi','Vin'];
    return isWorkingDay(date, workingDays);
  };

  // Update list după edit
  const handleSaveEdit = async () => {
    if (!selectedProd) return;
    if (!editForm.nrLot || !editForm.nrLot.trim()) {
      alert('Câmpul Nr. Lot este obligatoriu.');
      return;
    }
    try {
      const payload = {
        nrBuc: editForm.nrBuc !== '' ? parseInt(editForm.nrBuc, 10) : null,
        ramase: null,
        status: editForm.status || selectedProd.status,
        nrLot: editForm.nrLot || null,
        mecanicId: editForm.mecanicId ? parseInt(editForm.mecanicId, 10) : null,
        operatorId: editForm.operatorId ? parseInt(editForm.operatorId, 10) : null,
        rebuturiOperator: editForm.rebuturiOperator !== '' ? parseInt(editForm.rebuturiOperator, 10) : null,
        rebuturiCuptor: editForm.rebuturiCuptor !== '' ? parseInt(editForm.rebuturiCuptor, 10) : null,
        rebuturiMasinaSuflat: editForm.rebuturiMasinaSuflat !== '' ? parseInt(editForm.rebuturiMasinaSuflat, 10) : null,
        rebuturiReglaje: editForm.rebuturiReglaje !== '' ? parseInt(editForm.rebuturiReglaje, 10) : null,
        rebuturiSefTura: editForm.rebuturiSefTura !== '' ? parseInt(editForm.rebuturiSefTura, 10) : null,
        rebuturiPreforma: editForm.rebuturiPreforma !== '' ? parseInt(editForm.rebuturiPreforma, 10) : null,
        produsId: selectedProd.produs_id || selectedProd.produsId,
        clientId: selectedProd.client_id || selectedProd.clientId,
        preformaId: selectedProd.preforma_id || selectedProd.preformaId || null,
        statieId: selectedProd.statie_id || selectedProd.statieId || null,
        dataLivrare: selectedProd.data_livrare || selectedProd.dataLivrare,
        currentUser: 'calendar'
      };
      // păstrăm date start/terminare existente
      payload.dataStart = selectedProd.dataStart || selectedProd.data_start;
      payload.dataTerminare = selectedProd.dataTerminare || selectedProd.data_terminare;
      const res = await axios.put(`${API_BASE_URL}/planificare-productie/${selectedProd.id}`, payload);
      const updated = res.data;
      const updatedWithDates = { ...updated, _start: toDateObj(updated.dataStart || updated.data_start), _end: toDateObj(updated.dataTerminare || updated.data_terminare) };
      
      // Actualizează state local
      setProductions(prev => prev.map(p => p.id === updated.id ? updatedWithDates : p));
      
      // Actualizează și state-ul principal dacă avem setPlanificare
      if (setPlanificare && typeof setPlanificare === 'function') {
        setPlanificare(prev => prev.map(p => p.id === updated.id ? updated : p));
      }
      
      setSelectedProd(null);
    } catch (e) {
      alert(e.response?.data?.error || 'Eroare la salvare');
    }
  };

  const openEdit = (p) => {
    setSelectedProd(p);
    const bucPerSac = (() => {
      const prod = produse.find(pr => pr.id === (p.produs_id || p.produsId));
      return prod && prod.bucPerSac > 0 ? prod.bucPerSac : 0;
    })();
    const nrBuc = p.nr_buc || p.nrBuc || '';
    const nrSaci = bucPerSac > 0 && nrBuc !== '' ? String(Math.round(parseInt(nrBuc, 10) / bucPerSac)) : '';
    setEditForm({
      nrSaci,
      nrBuc: String(nrBuc),
      status: p.status || '',
      nrLot: p.nrLot || p.nr_lot || '',
      mecanicId: p.mecanicId != null ? String(p.mecanicId) : '',
      operatorId: (p.operatorId || p.operator_id) != null ? String(p.operatorId || p.operator_id) : '',
      rebuturiOperator: p.rebuturiOperator != null ? String(p.rebuturiOperator) : '',
      rebuturiCuptor: p.rebuturiCuptor != null ? String(p.rebuturiCuptor) : '',
      rebuturiMasinaSuflat: p.rebuturiMasinaSuflat != null ? String(p.rebuturiMasinaSuflat) : '',
      rebuturiReglaje: p.rebuturiReglaje != null ? String(p.rebuturiReglaje) : '',
      rebuturiSefTura: p.rebuturiSefTura != null ? String(p.rebuturiSefTura) : '',
      rebuturiPreforma: p.rebuturiPreforma != null ? String(p.rebuturiPreforma) : ''
    });
  };

  const closeEdit = () => { setSelectedProd(null); };

  const handleDelete = async () => {
    if (!selectedProd) return;
    if (!window.confirm('Ești sigur că vrei să ștergi această comandă de lucru? Acțiunea nu poate fi anulată.')) return;
    try {
      await axios.delete(`${API_BASE_URL}/planificare-productie/${selectedProd.id}`);
      setProductions(prev => prev.filter(p => p.id !== selectedProd.id));
      if (setPlanificare && typeof setPlanificare === 'function') {
        setPlanificare(prev => prev.filter(p => p.id !== selectedProd.id));
      }
      setSelectedProd(null);
    } catch (e) {
      alert(e.response?.data?.error || 'Eroare la ștergere');
    }
  };

  const openMaterialeModal = async (date) => {
    setMaterialeModal(date);
    try {
      const res = await axios.get(`${API_BASE_URL}/calendar-materiale/${date}`);
      const { scotch, hartie, saci = [] } = res.data;
      const saciMap = {};
      saci.forEach(s => { saciMap[s.sacId] = s.nrSaci != null ? String(s.nrSaci) : ''; });
      setMaterialeForm({ scotch: scotch != null ? String(scotch) : '', hartie: hartie != null ? String(hartie) : '', saci: saciMap });
    } catch {
      setMaterialeForm({ scotch: '', hartie: '', saci: {} });
    }
  };

  const closeMaterialeModal = () => setMaterialeModal(null);

  const handleSaveMateriale = async () => {
    const date = materialeModal;
    if (!date) return;
    try {
      const payload = {
        scotch: materialeForm.scotch !== '' ? parseFloat(materialeForm.scotch) : null,
        hartie: materialeForm.hartie !== '' ? parseFloat(materialeForm.hartie) : null,
        saci: saciTypes
          .map(s => ({ sacId: s.id, nrSaci: materialeForm.saci[s.id] !== '' && materialeForm.saci[s.id] != null ? parseFloat(materialeForm.saci[s.id]) : null }))
          .filter(x => x.nrSaci != null)
      };
      await axios.patch(`${API_BASE_URL}/calendar-materiale/${date}`, payload);
      setMaterialeData(prev => ({ ...prev, [date]: payload }));
      closeMaterialeModal();
    } catch (e) {
      alert(e.response?.data?.error || 'Eroare la salvare');
    }
  };

  const openCreateSlot = (slot) => {
    const genericClient = clienti.find(client => String(client.nume || '').trim().toLowerCase() === 'generic');
    setSelectedCreateSlot(slot);
    setCreateForm({
      produsId: '',
      preformaId: '',
      operatorId: '',
      clientId: genericClient ? String(genericClient.id) : '',
      nrSaci: '',
      nrBuc: '',
      dataLivrare: slot.date,
      startTime: slot.startTime,
      endTime: slot.endTime,
      status: 'În desfășurare',
      observatii: ''
    });
    setError('');
  };

  const closeCreateSlot = () => {
    setSelectedCreateSlot(null);
    setCreateForm({
      produsId: '',
      preformaId: '',
      operatorId: '',
      clientId: '',
      nrSaci: '',
      nrBuc: '',
      dataLivrare: '',
      startTime: '',
      endTime: '',
      status: 'În desfășurare',
      observatii: ''
    });
  };

  const handleCreateFormChange = (field, value) => {
    setCreateForm(prev => {
      const updated = { ...prev, [field]: value };
      if (field === 'nrSaci' || field === 'produsId') {
        const produsId = field === 'produsId' ? value : prev.produsId;
        const nrSaci = field === 'nrSaci' ? value : prev.nrSaci;
        const prod = produse.find(p => String(p.id) === String(produsId));
        if (prod && prod.bucPerSac > 0 && nrSaci !== '') {
          const qty = parseInt(nrSaci, 10);
          if (Number.isFinite(qty) && qty > 0) {
            updated.nrBuc = String(qty * prod.bucPerSac);
          }
        }
      }
      return updated;
    });
  };

  const handleSaveCreate = async () => {
    if (!selectedCreateSlot) return;
    if (!createForm.produsId || !createForm.startTime || !createForm.endTime) {
      setError('Completează produsul și intervalul de timp.');
      return;
    }

    const nrBuc = createForm.nrBuc !== '' ? parseInt(createForm.nrBuc, 10) : null;
    if (nrBuc !== null && (!Number.isFinite(nrBuc) || nrBuc <= 0)) {
      setError('Cantitatea trebuie să fie un număr valid mai mare decât 0.');
      return;
    }

    const slotDate = selectedCreateSlot.date;
    const dataStart = `${slotDate} ${createForm.startTime}`;
    const dataTerminare = `${slotDate} ${createForm.endTime}`;
    const startDate = toDateObj(dataStart);
    const endDate = toDateObj(dataTerminare);

    if (!startDate || !endDate || endDate <= startDate) {
      setError('Ora de terminare trebuie să fie după ora de start.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const payload = {
        dataIntrare: new Date().toISOString().split('T')[0],
        produsId: parseInt(createForm.produsId, 10),
        preformaId: createForm.preformaId ? parseInt(createForm.preformaId, 10) : null,
        operatorId: createForm.operatorId ? parseInt(createForm.operatorId, 10) : null,
        nrBuc,
        clientId: createForm.clientId ? parseInt(createForm.clientId, 10) : null,
        statieId: selectedCreateSlot.statieId,
        dataLivrare: createForm.dataLivrare || slotDate,
        dataStart,
        dataTerminare,
        status: createForm.status || 'În așteptare',
        observatii: createForm.observatii.trim() || null,
        createdBy: 'calendar',
        currentUser: 'calendar'
      };

      const res = await axios.post(`${API_BASE_URL}/planificare-productie`, payload);
      const created = res.data;
      const createdWithDates = {
        ...created,
        _start: toDateObj(created.dataStart || created.data_start),
        _end: toDateObj(created.dataTerminare || created.data_terminare || created.dataLivrare || created.data_livrare)
      };

      setProductions(prev => [createdWithDates, ...prev]);
      if (setPlanificare && typeof setPlanificare === 'function') {
        setPlanificare(prev => [created, ...(Array.isArray(prev) ? prev : [])]);
      }

      closeCreateSlot();
    } catch (e) {
      setError(e.response?.data?.error || 'Eroare la crearea comenzii de lucru.');
    } finally {
      setLoading(false);
    }
  };

  // Month view renderer
  const renderMonthView = () => {
    const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const startDate = new Date(firstDayOfMonth);
    
    // Start from Monday of the week containing the first day
    const dayOfWeek = firstDayOfMonth.getDay();
    const daysToSubtract = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
    startDate.setDate(firstDayOfMonth.getDate() - daysToSubtract);

    const days = [];
    for (let i = 0; i < 42; i++) { // 6 weeks * 7 days
      const day = new Date(startDate);
      day.setDate(startDate.getDate() + i);
      days.push(day);
    }

    return (
      <div className="calendar-month">
        <div className="calendar-header">
          <div className="calendar-weekdays">
            {['Lun', 'Mar', 'Mie', 'Joi', 'Vin', 'Sâm', 'Dum'].map(day => (
              <div key={day} className="weekday-header">{day}</div>
            ))}
          </div>
        </div>
        <div className="calendar-grid">
          {days.map((day, index) => {
            const dayIso = formatISODate(day);
            const dayEvents = productions.filter(p => {
              const s = p._start; const e = p._end;
              if (!s || !e) return false;
              // comparăm doar pe zile (ignor orele)
              const dayStartMidnight = new Date(dayIso + 'T00:00:00');
              const dayEndMidnight = new Date(dayIso + 'T23:59:59');
              if (!(s <= dayEndMidnight && e >= dayStartMidnight)) return false;
              // Respectăm programul stației: dacă există stația și nu lucrează în ziua curentă, nu afișăm producția pentru acea zi
              const st = getStatieForEvent(p);
              if (st && !isStationWorkingOnDay(st, day)) return false;
              if (!eventMatchesSelectedTure(p)) return false;
              return true;
            }).slice(0,4);
            const dayChanges = schimburi.filter(s => s.date === dayIso).slice(0, 2); // limit vizual
            return (
              <div
                key={index}
                className={`calendar-day ${isSameDay(day, today) ? 'today' : ''} ${!isSameMonth(day, currentDate) ? 'other-month' : ''}`}
              >
                <span className="day-number">{day.getDate()}</span>
                <div className="day-events">
                  {dayChanges.map(ev => (
                    <div 
                      key={`chg-${ev.id}`} 
                      className="event-chip change-chip" 
                      style={{background: '#dc3545', color: '#fff'}}
                      title={`Schimb matriță: ${ev.produs} ${ev.startTime}-${ev.endTime}`}
                    >
                      🔁 Schimb: {ev.startTime}-{ev.endTime} • {ev.produs}
                    </div>
                  ))}
                  {dayEvents.map(ev => (
                    <div key={ev.id} className={`event-chip status-${statusSlug(ev.status)}`} onClick={()=>openEdit(ev)} title={`${ev.produs||ev.produs_nume||''} (${ev.nr_buc||ev.nrBuc||''})`} style={{
                      // Culoare fundal per tură dacă este definită
                      backgroundColor: getEventShiftColor(ev) || undefined,
                      color: getEventShiftColor(ev) ? '#000' : undefined
                    }}>
                      {(ev.produs || ev.produs_nume || 'Produs')} {ev.ramase!=null?`(${ev.ramase})`:''}
                    </div>
                  ))}
                  {productions.filter(p=>{
                    const s=p._start; const e=p._end; if(!s||!e) return false;
                    const dayStartMidnight=new Date(dayIso+'T00:00:00'); const dayEndMidnight=new Date(dayIso+'T23:59:59');
                    if (!(s <= dayEndMidnight && e >= dayStartMidnight)) return false;
                    const st = getStatieForEvent(p);
                    if (st && !isStationWorkingOnDay(st, day)) return false;
                    if (!eventMatchesSelectedTure(p)) return false;
                    return true;
                  }).length>4 && <div className="more-events">…</div>}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  // Formatare ora mm->HH:MM
  const fmtHM = (minutes) => {
    if (minutes == null) return '';
    const h = Math.floor(minutes/60); const m = minutes%60; return `${h.toString().padStart(2,'0')}:${m.toString().padStart(2,'0')}`;
  };

  // Week view pivotat pe stații
  const renderWeekView = () => {
    const startOfWeek = new Date(currentDate);
    const dayOfWeek = currentDate.getDay();
    const daysToSubtract = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
    startOfWeek.setDate(currentDate.getDate() - daysToSubtract);
    const weekDays = [];
    for (let i = 0; i < 7; i++) { const d = new Date(startOfWeek); d.setDate(startOfWeek.getDate()+i); if (d.getDay() !== 0 && d.getDay() !== 6) weekDays.push(d); }

    const sortedStatii = [...statii].sort((a,b)=> (a.denumire||'').localeCompare(b.denumire||''));
    const stationGroups = Object.values(sortedStatii.reduce((acc, s) => {
      const name = (s.denumire || `Stație ${s.id}`).trim();
      acc[name] = acc[name] || [];
      acc[name].push(s);
      return acc;
    }, {}));

    return (
      <div className="station-week">
        <div className="station-week-header">
          <div className="sw-cell sw-statie-col head">Stație</div>
          {weekDays.map(d => (
            <div key={d.toISOString()} className={`sw-cell sw-day-col head ${isSameDay(d,today)?'today':''}`}>
              <div className="sw-day-name">{getShortDayName(d)}</div>
              <div className="sw-day-date">{d.getDate()}</div>
            </div>
          ))}
        </div>
        <div className="station-week-body">
          <div className="sw-row sw-materiale-row">
            <div className="sw-cell sw-statie-col body sw-materiale-label">
              <span className="sw-mat-title">Materiale Adiacente</span>
            </div>
            {weekDays.map(d => {
              const dayIso = formatISODate(d);
              const saved = materialeData[dayIso];
              const hasSaved = saved && (saved.scotch != null || saved.hartie != null || (saved.saci && saved.saci.length > 0));
              return (
                <div key={`mat-${dayIso}`} className="sw-cell sw-day-col body sw-materiale-cell">
                  <button className={`sw-mat-btn${hasSaved ? ' has-data' : ''}`} onClick={() => openMaterialeModal(dayIso)}>
                    {hasSaved ? '✎ Materiale' : '+ Materiale Adiacente'}
                  </button>
                  {hasSaved && (
                    <div className="sw-mat-summary">
                      {saved.scotch != null && <span>Scotch: {saved.scotch}</span>}
                      {saved.hartie != null && <span>Hârtie: {saved.hartie}</span>}
                      {saved.saci && saved.saci.length > 0 && <span>Saci: {saved.saci.length} tip{saved.saci.length !== 1 ? 'uri' : ''}</span>}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          {stationGroups.map((group, gi) => {
            const groupName = group[0].denumire || `Stație ${group[0].id}`;
            return (
              <div key={`group-${gi}-${groupName}`} className="sw-row grouped-row">
                <div className="sw-cell sw-statie-col body grouped-station-name">
                  <div className="sw-st-name">{groupName}</div>
                </div>
                {weekDays.map(d => {
                  const dayIso = formatISODate(d);
                  const changes = schimburi.filter(s => s.date === dayIso);
                  const dayStart = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0,0,0,0);
                  const dayEnd = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23,59,59,999);
                  
                  return (
                    <div key={`g-${gi}-${d.toISOString()}`} className={`sw-cell sw-day-col body ${isSameDay(d,today)?'today':''}`}>
                      {group.map(st => {
                        const workStart = parseHM(st.intervalFunc, 8*60);
                        const workEnd = parseHM(st.sfarsit, 16*60);
                        const stationWorking = isStationWorkingOnDay(st, d);
                        const slotMeta = {
                          statieId: st.id,
                          statieName: st.denumire || `Stație ${st.id}`,
                          date: dayIso,
                          dateLabel: formatDateLabel(dayIso),
                          startTime: fmtHM(workStart),
                          endTime: fmtHM(workEnd)
                        };
                        if (!stationWorking) {
                          return (
                            <div key={`st-${st.id}-nw`} className="st-variant non-working">
                              <div className="st-variant-name">{st.denumire || `Stație ${st.id}`}</div>
                              <div className="st-variant-hours">Zi nelucru</div>
                            </div>
                          );
                        }
                        
                        // DEFINIȚIE EVENTS PENTRU WEEK VIEW
                        const events = productions.filter(ev => {
                          const sid = ev.statie_id || ev.statieId; if (sid !== st.id) return false;
                          if (!ev._start || !ev._end) return false;
                          if (!(ev._start <= dayEnd && ev._end >= dayStart)) return false;
                          if (!eventMatchesSelectedTure(ev)) return false;
                          return true;
                        }).map(ev => {
                          let startMin = isSameDay(ev._start, d) ? ev._start.getHours()*60 + ev._start.getMinutes() : workStart;
                          let endMin = isSameDay(ev._end, d) ? ev._end.getHours()*60 + ev._end.getMinutes() : workEnd;
                          if (startMin < workStart) startMin = workStart;
                          if (endMin > workEnd) endMin = workEnd;
                          if (endMin < startMin) endMin = startMin;
                          return { raw: ev, startMin, endMin };
                        }).sort((a,b)=> a.startMin - b.startMin);
                        
                        // Filtrăm schimburile de matriță pentru această stație
                        const relevantChanges = changes.filter(c => {
                          const isForThisStation = !c.statieId || c.statieId === st.id ||
                            (c.statie && c.statie.toLowerCase() === (st.denumire || '').toLowerCase());
                          if (!isForThisStation) return false;
                          
                          const [chh, cmm] = c.startTime.split(':').map(Number);
                          const changeStartMin = chh * 60 + cmm;
                          
                          return changeStartMin >= workStart && changeStartMin < workEnd;
                        });

                        return (
                          <div key={`st-${st.id}`} className="st-variant">
                            <div className="st-variant-header">
                              <span className="st-hours">{fmtHM(workStart)}-{fmtHM(workEnd)}</span>
                            </div>
                            <div
                              className="st-variant-events slot-target"
                              onClick={() => openCreateSlot(slotMeta)}
                              role="button"
                              tabIndex={0}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                  e.preventDefault();
                                  openCreateSlot(slotMeta);
                                }
                              }}
                            >
                              {relevantChanges.length > 0 && relevantChanges.map(c => (
                                <div 
                                  key={`chg-${c.id}`} 
                                  className="sw-ev change-ev" 
                                  style={{background: '#dc3545', color: '#fff'}}
                                  title={`Schimb matriță: ${c.produs} la ${c.statie || 'stația'} ${c.startTime}-${c.endTime}`}
                                >
                                  <div className="sw-ev-line">
                                    <span className="sw-time">{c.startTime}-{c.endTime}</span> 
                                    <span className="sw-prod">Schimb: {c.produs}</span>
                                  </div>
                                </div>
                              ))}
                                {events.length === 0 ? (
                                  <div className="sw-empty">Apasă pentru a crea o comandă</div>
                                ) : events.map(({raw,startMin,endMin})=>{
                                const prod = raw.produs || raw.produs_nume || 'Produs';
                                const op = raw.operator || raw.operator_nume || raw.operatorNume || '';
                                const range = `${fmtHM(startMin)}-${fmtHM(endMin)}`;
                                return (
                                    <div key={raw.id+':'+startMin} className={`sw-ev status-${statusSlug(raw.status)}`} onClick={(e)=>{ e.stopPropagation(); openEdit(raw); }} title={`${prod}\n${op?op+'\n':''}${range}`} style={{
                                    backgroundColor: getEventShiftColor(raw) || undefined,
                                    color: getEventShiftColor(raw) ? '#000' : undefined
                                  }}>
                                    <div className="sw-ev-line"><span className="sw-time">{range}</span> <span className="sw-prod">{prod}</span></div>
                                    <div className="sw-ev-meta">{op || <span className="sw-no-op">(fără operator)</span>} {raw.ramase!=null?` • R:${raw.ramase}`:''}</div>
                                  </div>
                                );
                              })}
                              {events.length > 0 && (
                                <button
                                  className="sw-add-more"
                                  onClick={(e) => { e.stopPropagation(); openCreateSlot(slotMeta); }}
                                  title="Adaugă o nouă comandă în acest slot"
                                >
                                  + Comandă nouă
                                </button>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  // Day view
  const renderDayView = () => {
    const d = currentDate;
    const dayIso = formatISODate(d);
    const dayChanges = schimburi.filter(s => s.date === dayIso);
    const sortedStatii = [...statii].sort((a,b)=>(a.denumire||'').localeCompare(b.denumire||''));
    const stationGroups = Object.values(sortedStatii.reduce((acc, s) => {
      const name = (s.denumire || `Stație ${s.id}`).trim();
      acc[name] = acc[name] || [];
      acc[name].push(s);
      return acc;
    }, {}));

    return (
      <div className="station-day">
        <div className="station-day-header">
          <h3>{getDayName(d)}, {d.getDate()} {getMonthName(d)} {d.getFullYear()}</h3>
        </div>
        <div className="station-day-body">
          <table className="sd-table" style={{width:'100%',borderCollapse:'collapse'}}>
            <thead>
              <tr className="sd-head-row multi">
                <th className="sd-cell sd-statie head">Stație</th>
                <th className="sd-cell sd-col head">Interval</th>
                <th className="sd-cell sd-col head">Produs</th>
                <th className="sd-cell sd-col head">Rămase</th>
                <th className="sd-cell sd-col head">Preforma</th>
                <th className="sd-cell sd-col head">Furnizor</th>
                <th className="sd-cell sd-col head">Operator</th>
              </tr>
            </thead>
            <tbody>
              {stationGroups.map((group) => {
                const variants = group;
                const rowCount = variants.length;
                return variants.map((st, idx) => {
                  const workStart = parseHM(st.intervalFunc, 8*60);
                  const workEnd = parseHM(st.sfarsit, 16*60);
                  const dayStart = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0,0,0,0);
                  const dayEnd = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23,59,59,999);
                  const stationWorking = isStationWorkingOnDay(st, d);

                  // Definim events ÎNAINTE de orice utilizare
                  const events = stationWorking ? productions.filter(ev => {
                    const sid = ev.statie_id || ev.statieId; 
                    if (sid !== st.id) return false;
                    if (!ev._start || !ev._end) return false;
                    if (!(ev._start <= dayEnd && ev._end >= dayStart)) return false;
                    if (!eventMatchesSelectedTure(ev)) return false;
                    return true;
                  }).map(ev => {
                    let startMin = isSameDay(ev._start, d) ? ev._start.getHours()*60 + ev._start.getMinutes() : workStart;
                    let endMin = isSameDay(ev._end, d) ? ev._end.getHours()*60 + ev._end.getMinutes() : workEnd;
                    if (startMin < workStart) startMin = workStart;
                    if (endMin > workEnd) endMin = workEnd;
                    if (endMin < startMin) endMin = startMin;
                    return { raw: ev, startMin, endMin };
                  }).sort((a,b)=> a.startMin - b.startMin) : [];

                  // Filtrăm schimburile de matriță pentru această stație și interval de timp
                  const relevantChanges = dayChanges.filter(c => {
                    const isForThisStation = !c.statieId || c.statieId === st.id || 
                      (c.statie && c.statie.toLowerCase() === (st.denumire || '').toLowerCase());
                    if (!isForThisStation) return false;
                    
                    const [chh, cmm] = c.startTime.split(':').map(Number);
                    const changeStartMin = chh * 60 + cmm;
                    
                    return changeStartMin >= workStart && changeStartMin < workEnd;
                  });

                  if (!stationWorking) {
                    return (
                      <tr key={`st-${st.id}-${idx}`} className="sd-row multi non-working-station">
                        {idx === 0 && (
                          <td className="sd-cell sd-statie body" rowSpan={rowCount}>
                            <div className="sd-st-name">{group[0].denumire||`Stație ${group[0].id}`}</div>
                          </td>
                        )}
                        <td className="sd-cell sd-col body sd-empty" colSpan={6} style={{fontStyle:'italic', color:'#999'}}>
                          Stația nu funcționează {getDayKey(d).toLowerCase()}
                        </td>
                      </tr>
                    );
                  }

                  if (events.length === 0 && relevantChanges.length === 0) {
                    return (
                      <tr key={`st-${st.id}-${idx}`} className="sd-row multi">
                        {idx === 0 && (
                          <td className="sd-cell sd-statie body" rowSpan={rowCount}>
                            <div className="sd-st-name">{group[0].denumire||`Stație ${group[0].id}`}</div>
                          </td>
                        )}
                        <td className="sd-cell sd-col body sd-empty" colSpan={6}>(niciun job)</td>
                      </tr>
                    );
                  }

                  // Build display rows with 30min changeover gaps between different products
                  const CHANGE_DURATION = 30;
                  let cumulativeShift = 0;
                  let prevProdKey = null;
                  let prevEndShifted = null;
                  const displayRows = [];
                  
                  events.forEach((eObj, idxEv) => {
                    const raw = eObj.raw;
                    const currentKey = raw.produs_id || raw.produsId || raw.produs || raw.produs_nume || '';
                    if (idxEv > 0 && currentKey !== prevProdKey && prevEndShifted != null) {
                      const changeStart = prevEndShifted;
                      let changeEnd = changeStart + CHANGE_DURATION;
                      if (changeStart < workEnd) {
                        if (changeEnd > workEnd) changeEnd = workEnd;
                        displayRows.push({ type:'change', startMin: changeStart, endMin: changeEnd });
                        cumulativeShift += CHANGE_DURATION;
                        prevEndShifted = changeEnd;
                      }
                    }
                    const startMin = eObj.startMin + cumulativeShift;
                    const endMin = eObj.endMin + cumulativeShift;
                    prevProdKey = currentKey;
                    prevEndShifted = endMin;
                    displayRows.push({ type:'job', startMin, endMin, raw });
                  });

                  return (
                    <tr key={`st-${st.id}-${idx}`} className="sd-row">
                      {idx === 0 && (
                        <td className="sd-cell sd-statie body" rowSpan={rowCount}>
                          <div className="sd-st-name">{group[0].denumire||`Stație ${group[0].id}`}</div>
                        </td>
                      )}
                      <td className="sd-cell sd-col body">
                        {/* Eliminat "Tura X" și afișăm doar intervalul orar */}
                        {fmtHM(workStart)}-{fmtHM(workEnd)}
                      </td>
                      <td className="sd-cell sd-col body">
                        {/* Afișăm schimburile de matriță în celule separate */}
                        {dayChanges.filter(c => {
                          // Verificăm dacă schimbul e pentru această stație
                          const isForThisStation = !c.statieId || c.statieId === st.id || 
                            (c.statie && c.statie.toLowerCase() === (st.denumire || '').toLowerCase());
                          if (!isForThisStation) return false;
                          
                          // Verificăm dacă ora schimbului se încadrează în intervalul de lucru al stației
                          const [chh, cmm] = c.startTime.split(':').map(Number);
                          const changeStartMin = chh * 60 + cmm;
                          
                          return changeStartMin >= workStart && changeStartMin < workEnd;
                        }).map(c => (
                          <div 
                            key={`dc-${c.id}`} 
                            className="sd-change-item" 
                            style={{
                              backgroundColor: '#dc3545', 
                              color: '#fff',
                              padding: '3px 6px',
                              borderRadius: '4px',
                              marginBottom: '4px',
                              fontWeight: 'bold',
                              fontSize: '0.7rem'
                            }}
                          >
                            {c.startTime}-{c.endTime} Schimb: {c.produs}
                          </div>
                        ))}
                        
                        {/* Merge consecutive displayRows for the same product into a single box */}
                        {(() => {
                          const jobs = displayRows.filter(r => r.type === 'job');
                          if (!jobs || jobs.length === 0) return <div className="sd-empty">-</div>;

                          // Merge consecutive jobs that belong to the same product key
                          const merged = [];
                          jobs.forEach(j => {
                            const key = j.raw.produs_id || j.raw.produsId || j.raw.produs || j.raw.produs_nume || '';
                            if (merged.length === 0) {
                              merged.push({ key, start: j.startMin, end: j.endMin, raw: j.raw });
                            } else {
                              const last = merged[merged.length - 1];
                              // If same product and overlapping/adjacent (allow small tolerance), merge ranges
                              if (key === last.key && j.startMin <= last.end + 5) {
                                last.end = Math.max(last.end, j.endMin);
                              } else {
                                merged.push({ key, start: j.startMin, end: j.endMin, raw: j.raw });
                              }
                            }
                          });

                          return (
                            <div className="sd-shifts single">
                              {merged.map((m, i) => (
                                <div key={`merged-${i}`} className={`sd-shift`} onClick={() => m.raw && openEdit(m.raw)} title={m.raw && (m.raw.produs || m.raw.produs_nume || '')}>
                                  <div className="sd-shift-prod">
                                    <div className="sd-shift-item">{m.raw.produs || m.raw.produs_nume || 'Produs'}</div>
                                    <div className="sd-shift-time">{fmtHM(m.start)} - {fmtHM(m.end)}</div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          );
                        })()}
                      </td>
                      <td className="sd-cell sd-col body">{events.length > 0 && events[0]?.raw?.ramase != null ? events[0].raw.ramase : ''}</td>
                      <td className="sd-cell sd-col body">{events.length > 0 ? (events[0]?.raw?.preforma_nume || events[0]?.raw?.preforma || '') : ''}</td>
                      <td className="sd-cell sd-col body">{events.length > 0 ? (events[0]?.raw?.furnizor || '') : ''}</td>
                      <td className="sd-cell sd-col body">{events.length > 0 ? (events[0]?.raw?.operator || '') : ''}</td>
                    </tr>
                  );
                });
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  const handleNavigation = (direction) => {
    switch (viewMode) {
      case 'month':
        navigateMonth(direction);
        break;
      case 'week':
        navigateWeek(direction);
        break;
      case 'day':
        navigateDay(direction);
        break;
      default:
        break;
    }
  };

  const getNavigationLabel = () => {
    switch (viewMode) {
      case 'month':
        return `${getMonthName(currentDate)} ${currentDate.getFullYear()}`;
      case 'week':
        const startOfWeek = new Date(currentDate);
        const dayOfWeek = currentDate.getDay();
        const daysToSubtract = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
        startOfWeek.setDate(currentDate.getDate() - daysToSubtract);
        const endOfWeek = new Date(startOfWeek);
        endOfWeek.setDate(startOfWeek.getDate() + 6);
        
        return `${startOfWeek.getDate()} ${getMonthName(startOfWeek)} - ${endOfWeek.getDate()} ${getMonthName(endOfWeek)} ${endOfWeek.getFullYear()}`;
      case 'day':
        return `${getDayName(currentDate)}, ${currentDate.getDate()} ${getMonthName(currentDate)} ${currentDate.getFullYear()}`;
      default:
        return '';
    }
  };

  // Strip Romanian (and common) diacritics for PDF rendering
  const sd = (str) => String(str == null ? '' : str)
    .replace(/[ăÅ]/g, (c) => c === 'ă' ? 'a' : 'A')
    .replace(/[âÂ]/g, (c) => c === 'â' ? 'a' : 'A')
    .replace(/[îÎ]/g, (c) => c === 'î' ? 'i' : 'I')
    .replace(/[șşŞȘ]/g, (c) => /[șş]/.test(c) ? 's' : 'S')
    .replace(/[țţŢȚ]/g, (c) => /[țţ]/.test(c) ? 't' : 'T');

  // Shared PDF builder — returns { pdf, filename } or null if no data for the given ISO date string
  const buildReportPDF = (dateStr) => {
    if (!dateStr) { alert('Selectati o data pentru raport.'); return null; }

    const [ry, rm, rd] = dateStr.split('-').map(Number);
    const selDate = new Date(ry, rm - 1, rd);

    const finalizate = productions.filter(p => {
      if ((p.status || '').toLowerCase() !== 'finalizat') return false;
      const start = p._start || toDateObj(p.dataStart || p.data_start);
      const end = p._end || toDateObj(p.dataTerminare || p.data_terminare || p.dataLivrare || p.data_livrare);
      if (!start) return false;
      const startDay = new Date(start.getFullYear(), start.getMonth(), start.getDate());
      const endDay = end ? new Date(end.getFullYear(), end.getMonth(), end.getDate()) : startDay;
      return selDate >= startDay && selDate <= endDay;
    });

    if (finalizate.length === 0) {
      alert(`Nu exista comenzi de lucru finalizate pentru data de ${dateStr}.`);
      return null;
    }

    const grouped = {};
    finalizate.forEach(p => {
      const machineName = sd(p.masina || `Masina #${p.statieId || p.statie_id || '?'}`);

      if (!grouped[machineName]) grouped[machineName] = [];
      grouped[machineName].push(p);
    });

    const brandColor = [10, 46, 111];
    const pdf = new jsPDF('l', 'pt', 'a4');
    const pageW = pdf.internal.pageSize.getWidth();
    const pageH = pdf.internal.pageSize.getHeight();
    const margin = 28;

    const romanianDate = sd(`${selDate.getDate()} ${monthNames[selDate.getMonth()]} ${selDate.getFullYear()}`);

    pdf.setFillColor(...brandColor);
    pdf.rect(0, 0, pageW, 52, 'F');
    pdf.setTextColor(255, 255, 255);
    pdf.setFontSize(16);
    pdf.setFont('helvetica', 'bold');
    pdf.text('Younger Karom Production Company', margin, 20);
    pdf.setFontSize(10);
    pdf.setFont('helvetica', 'normal');
    pdf.text('Raport productie zilnica - Comenzi Finalizate', margin, 34);
    pdf.text(`Data: ${romanianDate}`, margin, 46);
    pdf.setTextColor(0, 0, 0);

    let curY = 60;
    const machineNames = Object.keys(grouped).sort();

    machineNames.forEach((machineName) => {
      const orders = grouped[machineName];

      if (curY + 80 > pageH - margin) {
        pdf.addPage();
        curY = margin;
      }

      pdf.setFillColor(232, 240, 254);
      pdf.rect(margin, curY, pageW - margin * 2, 20, 'F');
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(11);
      pdf.setTextColor(...brandColor);
      pdf.text(`Masina: ${machineName}  (${orders.length} comanda${orders.length !== 1 ? ' / comenzi' : ''})`, margin + 6, curY + 14);
      pdf.setTextColor(0, 0, 0);
      curY += 24;

      const tableHeaders = [
        ['Nr.', 'Produs', 'Preforma', 'Client', 'Nr. Buc', 'Nr. Lot', 'Operator', 'Mecanic',
         'Ora Start', 'Ora Term.', 'Reb. Op.', 'Reb. Cupt.', 'Reb. Maq.', 'Reb. Regl.',
         'Reb. S.T.', 'Reb. Pref.', 'Observatii']
      ];

      const fmt = (v) => sd(v != null && v !== '' ? String(v) : '-');
      const timeOf = (val) => {
        const d = toDateObj(val);
        if (!d) return '-';
        return `${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}`;
      };

      const tableRows = orders.map((p, idx) => [
        String(idx + 1),
        fmt(p.produs),
        fmt(p.preforma),
        fmt(p.client),
        fmt(p.nrBuc),
        fmt(p.nrLot),
        fmt(p.operator),
        fmt(p.mecanic),
        timeOf(p.dataStart || p.data_start),
        timeOf(p.dataTerminare || p.data_terminare),
        fmt(p.rebuturiOperator),
        fmt(p.rebuturiCuptor),
        fmt(p.rebuturiMasinaSuflat),
        fmt(p.rebuturiReglaje),
        fmt(p.rebuturiSefTura),
        fmt(p.rebuturiPreforma),
        fmt(p.observatii)
      ]);

      autoTable(pdf, {
        startY: curY,
        head: tableHeaders,
        body: tableRows,
        margin: { left: margin, right: margin },
        styles: { fontSize: 7, cellPadding: 3, overflow: 'linebreak' },
        headStyles: { fillColor: brandColor, textColor: [255, 255, 255], fontStyle: 'bold', fontSize: 7 },
        alternateRowStyles: { fillColor: [245, 248, 255] },
        columnStyles: {
          0:  { cellWidth: 20 },
          1:  { cellWidth: 65 },
          2:  { cellWidth: 55 },
          3:  { cellWidth: 55 },
          4:  { cellWidth: 38 },
          5:  { cellWidth: 38 },
          6:  { cellWidth: 55 },
          7:  { cellWidth: 55 },
          8:  { cellWidth: 38 },
          9:  { cellWidth: 38 },
          10: { cellWidth: 32 },
          11: { cellWidth: 32 },
          12: { cellWidth: 32 },
          13: { cellWidth: 32 },
          14: { cellWidth: 32 },
          15: { cellWidth: 32 },
          16: { cellWidth: 'auto' }
        },
        didDrawPage: (data) => {
          pdf.setFontSize(8);
          pdf.setTextColor(120, 120, 120);
          pdf.text(`Pagina ${data.pageNumber}`, pageW - margin, pageH - 10, { align: 'right' }); // 'Pagina' has no diacritics
          pdf.setTextColor(0, 0, 0);
        }
      });

      curY = pdf.lastAutoTable.finalY + 16;
    });

    return { pdf, filename: `raport_productie_${dateStr}.pdf` };
  };

  const handleGenerateReport = () => {
    const result = buildReportPDF(reportDate);
    if (result) result.pdf.save(result.filename);
  };

  const handleExportPDF = async () => {
    try {
      const { wrapper } = buildExportWrapper();
      // position: relative makes wrapper act as offsetParent for children
      wrapper.style.position = 'relative';
      document.body.appendChild(wrapper);

      // Collect bottom edge of every slot row, relative to wrapper top,
      // so we can split pages only at row boundaries (never through a row).
      const rowEls = Array.from(wrapper.querySelectorAll('.sw-row'));
      const rowBottomsDom = rowEls.map(r => {
        let top = 0;
        let cur = r;
        while (cur && cur !== wrapper) { top += cur.offsetTop; cur = cur.offsetParent; }
        return top + r.offsetHeight;
      });

      const CANVAS_SCALE = 2;
      const canvas = await html2canvas(wrapper, {
        scale: CANVAS_SCALE, useCORS: true, backgroundColor: '#ffffff',
        windowWidth: wrapper.scrollWidth
      });
      document.body.removeChild(wrapper);

      const pdf = new jsPDF('l', 'pt', 'a4');
      const pageWidth  = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 24;
      const usableWidth  = pageWidth  - margin * 2;
      const usableHeight = pageHeight - margin * 2;

      // imgScale: canvas px → PDF pt
      const imgScale = usableWidth / canvas.width;
      // max page height expressed in canvas pixels
      const maxPagePx = usableHeight / imgScale;

      // Convert row bottoms from DOM px to canvas px
      const rowBottomsPx = rowBottomsDom.map(b => b * CANVAS_SCALE);

      // Build non-overlapping page slices that never cut through a row
      const slices = [];
      let sliceStart = 0;
      let lastSafeEnd = 0; // bottom of last fully-fitting row

      for (let i = 0; i < rowBottomsPx.length; i++) {
        const rowBottom = rowBottomsPx[i];
        if (rowBottom - sliceStart > maxPagePx) {
          // This row would overflow the current page.
          // End the page at the last safe boundary.
          const cutAt = lastSafeEnd > sliceStart ? lastSafeEnd : rowBottom; // fallback if single row is taller than page
          slices.push({ start: sliceStart, end: cutAt });
          sliceStart = cutAt;
          lastSafeEnd = rowBottom; // current row now fits as the first row of the new page
        } else {
          lastSafeEnd = rowBottom;
        }
      }
      // Remaining content (including any non-row content below the last row)
      slices.push({ start: sliceStart, end: canvas.height });

      // Render each slice as a PDF page
      for (let i = 0; i < slices.length; i++) {
        if (i > 0) pdf.addPage();
        const { start, end } = slices[i];
        const sliceH = end - start;

        const sliceCanvas = document.createElement('canvas');
        sliceCanvas.width  = canvas.width;
        sliceCanvas.height = Math.ceil(sliceH);
        sliceCanvas.getContext('2d').drawImage(
          canvas, 0, start, canvas.width, sliceH,
          0, 0, canvas.width, sliceH
        );

        pdf.addImage(sliceCanvas.toDataURL('image/png'), 'PNG',
          margin, margin, usableWidth, sliceH * imgScale);
      }

      pdf.save(`calendar_${viewMode}_${Date.now()}.pdf`);
    } catch (err) {
      console.error('Export PDF error:', err);
      alert('Eroare la generarea PDF: ' + (err.message || 'necunoscuta'));
    }
  };

  const handlePrint = () => {
    const result = buildReportPDF(reportDate);
    if (!result) return;
    result.pdf.autoPrint();
    const blob = result.pdf.output('blob');
    const url = URL.createObjectURL(blob);
    const win = window.open(url, '_blank');
    if (win) win.focus();
    // revoke after a short delay to allow the browser to load the blob
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  };

  const handlePrintOld = async () => {
    try {
      const old = document.getElementById('__print_wrapper'); if (old) old.remove();
      const { wrapper } = buildExportWrapper();
      wrapper.id = '__print_wrapper';
      
      // Adăugăm o clasă în funcție de modul de vizualizare pentru a putea aplica stiluri specifice
      wrapper.classList.add(`${viewMode}-view`);
      
      document.body.appendChild(wrapper);

      // Calculăm un factor de scalare pentru a încăpea TOT calendarul pe o singură pagină (fără a tăia jos)
      // Funcționează cel mai relevant pentru modul săptămânal (când e foarte înalt) dar îl aplicăm generic.
      // Forțăm orientarea de print la landscape pentru orice view
      const orientation = 'landscape';
      // Dimensiuni A4 în mm
      const pageWidthMm = orientation==='landscape' ? 297 : 210;
      const pageHeightMm = orientation==='landscape' ? 210 : 297;
      const marginMm = 10; // definit și în CSS @page
      const usableWidthMm = pageWidthMm - marginMm*2;
      const usableHeightMm = pageHeightMm - marginMm*2;
      const pxPerMm = 96/25.4; // conversie aproximativă px CSS / mm
      const usableWidthPx = usableWidthMm * pxPerMm;
      const usableHeightPx = usableHeightMm * pxPerMm;

      // Măsurăm dimensiunile reale înainte de scalare
      const contentWidth = wrapper.offsetWidth;
      const contentHeight = wrapper.offsetHeight;
      let scaleFactor = 1;
      if (contentWidth > 0 && contentHeight > 0) {
        const scaleW = usableWidthPx / contentWidth;
        const scaleH = usableHeightPx / contentHeight;
        // Ajustăm factorul de scalare pentru a asigura că tot calendarul încape în pagină
        // Folosim 0.95 în loc de 0.85 pentru a mări mai puțin
        scaleFactor = Math.min(scaleW, scaleH, 0.95); 
      }
      
      // Factor de siguranță ajustat pentru fiecare tip de vizualizare
      if (viewMode === 'week' && scaleFactor < 1) {
        scaleFactor *= 0.98; // Reducem mai puțin pentru săptămână
      } else if (viewMode === 'month') {
        scaleFactor *= 0.95; // Reducem mai puțin pentru luna
      } else if (viewMode === 'day') {
        scaleFactor *= 0.92; // Reducem mai puțin pentru zi
      }

      // Construim un container ce va fi scalat; astfel wrapper-ul poate avea înălțimea redusă efectiv pentru pagination avoidance
      const scaleContainer = document.createElement('div');
      scaleContainer.className = 'print-scale-container';
      while (wrapper.firstChild) scaleContainer.appendChild(wrapper.firstChild);
      wrapper.appendChild(scaleContainer);

      // La print, scalarea se va face prin CSS (@media print), dar pregătim dimensiunile aici
      if (scaleFactor < 1) {
        scaleContainer.style.transform = `scale(${scaleFactor})`;
        scaleContainer.style.transformOrigin = 'top left';
        // setăm dimensiunile wrapper-ului la dimensiunile scalate pentru a preveni page break suplimentar
        wrapper.style.width = (contentWidth * scaleFactor) + 'px';
        wrapper.style.height = (contentHeight * scaleFactor) + 'px';
        wrapper.style.overflow = 'hidden';
      }

      // CSS pentru a ascunde totul în afară de wrapper + prevenim page breaks
      // Am mutat majoritatea stilurilor în App.css, aici setăm doar orientarea paginii
      if (!document.getElementById('__print_css_html')) {
        const style = document.createElement('style');
        style.id='__print_css_html';
        style.textContent = `@media print { @page { size: ${orientation}; margin:10mm; } }`;
        document.head.appendChild(style);
      } else {
        // actualizăm doar orientarea dacă s-a schimbat
        const style = document.getElementById('__print_css_html');
        style.textContent = style.textContent.replace(/@page { size: ([^;]+); margin:10mm; }/, `@page { size: ${orientation}; margin:10mm; }`);
      }
      
      // marcăm body
      document.body.classList.add('printing-calendar');
      await new Promise(res=>requestAnimationFrame(res));
      const cleanup = () => { document.body.classList.remove('printing-calendar'); const w=document.getElementById('__print_wrapper'); if(w) w.remove(); };
      if ('onafterprint' in window) {
        const prev = window.onafterprint;
        window.onafterprint = () => { cleanup(); if (typeof prev==='function') prev(); };
      } else { setTimeout(cleanup, 500); }
      window.print();
    } catch(e) {
      console.error('Print error', e);
      alert('Eroare la print: '+(e.message||'necunoscută'));
    }
  };

  return (
    <div className={`calendar-container screen-only ${viewMode}-view`} ref={calendarRef}>
      <div className="calendar-controls">
        <div className="view-controls">
          <button
            className={`view-btn ${viewMode === 'month' ? 'active' : ''}`}
            onClick={() => setViewMode('month')}
          >
            Lună
          </button>
          <button
            className={`view-btn ${viewMode === 'week' ? 'active' : ''}`}
            onClick={() => setViewMode('week')}
          >
            Săptămână
          </button>
          <button
            className={`view-btn ${viewMode === 'day' ? 'active' : ''}`}
            onClick={() => setViewMode('day')}
          >
            Zi
          </button>
        </div>
        
        <div className="navigation-controls">
          <button className="nav-btn" onClick={() => handleNavigation(-1)}>
            ‹
          </button>
          <span className="current-period">{getNavigationLabel()}</span>
          <button className="nav-btn" onClick={() => handleNavigation(1)}>
            ›
          </button>
        </div>
        
        <div className="ture-filter">
          <div className="ture-dropdown">
            <button className="ture-dropdown-toggle" onClick={() => setTureDropdownOpen(o=>!o)}>
              Ture ▾
            </button>
            {tureDropdownOpen && (
              <div className="ture-dropdown-panel">
                <div className="ture-dropdown-row">
                  <label style={{fontWeight:700}}>Afișează:</label>
                  <button
                    className="tura-chip small"
                    onClick={() => {
                      const allNames = (Array.isArray(tureMeta) ? tureMeta.map(t=> (t && (t.name||t)) || '') : []).filter(Boolean);
                      const allSelected = allNames.length > 0 && allNames.every(n => selectedTureFilters.includes(n));
                      setSelectedTureFilters(allSelected ? [] : allNames);
                    }}
                  >Toate</button>
                </div>
                <div className="ture-list">
                  {tureMeta.map(t => {
                    const name = t.name || t;
                    const checked = selectedTureFilters.includes(name);
                    return (
                      <label key={name} className="ture-checkbox-row">
                        <input type="checkbox" checked={checked} onChange={() => {
                          setSelectedTureFilters(prev => prev.includes(name) ? prev.filter(x=>x!==name) : [...prev, name]);
                        }} />
                        <span className="ture-label" style={{background: t.color || 'transparent'}}>{name}</span>
                      </label>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
        
        <div className="right-actions">
          <button className="today-btn" onClick={goToToday}>Astăzi</button>
          <div className="report-group">
            <input
              type="date"
              className="report-date-input"
              value={reportDate}
              onChange={e => setReportDate(e.target.value)}
              title="Selectați data pentru raport"
            />
            <button className="report-btn" onClick={handleGenerateReport} title="Generează raport PDF pentru ziua selectată">
              Generează Raport
            </button>
          </div>
          <button className="print-btn" onClick={handlePrint} title="Printează">Print</button>
          <button className="export-btn" onClick={handleExportPDF} title="Descarcă PDF">PDF</button>
        </div>
      </div>

      {error && <div className="calendar-error-banner">{error}</div>}

      <div className="calendar-content">
        {viewMode === 'month' && renderMonthView()}
        {viewMode === 'week' && renderWeekView()}
        {viewMode === 'day' && renderDayView()}
      </div>

      {materialeModal && ReactDOM.createPortal(
        <div className="edit-modal-overlay" onClick={closeMaterialeModal}>
          <div className="edit-modal materiale-modal" onClick={e => e.stopPropagation()}>
            <h3>Adaugă Materiale Adiacente</h3>
            <div className="mat-modal-date">{materialeModal}</div>

            <div className="form-section-header">Saci</div>
            {saciTypes.length === 0
              ? <p className="mat-no-types">Nu există tipuri de saci definite.</p>
              : saciTypes.map(sac => (
                <div key={sac.id} className="form-row">
                  <label>{sac.denumire}{sac.cod ? ` (${sac.cod})` : ''}</label>
                  <input
                    type="number" min="0"
                    value={materialeForm.saci[sac.id] || ''}
                    placeholder="0"
                    onChange={e => setMaterialeForm(f => ({ ...f, saci: { ...f.saci, [sac.id]: e.target.value } }))}
                  />
                </div>
              ))
            }

            <div className="form-section-header">Scotch</div>
            <div className="form-row">
              <label>Bucăți</label>
              <input type="number" min="0" value={materialeForm.scotch} placeholder="0"
                onChange={e => setMaterialeForm(f => ({ ...f, scotch: e.target.value }))} />
            </div>

            <div className="form-section-header">Hârtie</div>
            <div className="form-row">
              <label>Bucăți</label>
              <input type="number" min="0" value={materialeForm.hartie} placeholder="0"
                onChange={e => setMaterialeForm(f => ({ ...f, hartie: e.target.value }))} />
            </div>

            <div className="modal-actions">
              <button className="btn btn-primary" onClick={handleSaveMateriale}>Salvează</button>
              <button className="btn btn-secondary" onClick={closeMaterialeModal}>Anulează</button>
            </div>
          </div>
        </div>,
        document.body
      )}

      {selectedProd && ReactDOM.createPortal(
        <div className="edit-modal-overlay" onClick={closeEdit}>
          <div className="edit-modal" onClick={(e)=>e.stopPropagation()}>
            <h3>Editare Producție</h3>
            <div className="form-row">
              <label>Nr. Lot <span style={{color:'#e53e3e'}}>*</span></label>
              <input type="text" required value={editForm.nrLot} onChange={e=>setEditForm(f=>({...f,nrLot:e.target.value}))} />
            </div>
            <div className="form-row">
              <label>Produs:</label>
              <div className="readonly-field">{selectedProd.produs || selectedProd.produs_nume || selectedProd.produsId || selectedProd.produs_id}</div>
            </div>
            <div className="form-row">
              <label>Nr. Saci: <span className="field-optional">(opțional)</span></label>
              <input type="number" min="1" value={editForm.nrSaci} onChange={e => {
                const val = e.target.value;
                const prod = produse.find(pr => pr.id === (selectedProd.produs_id || selectedProd.produsId));
                const bucPerSac = prod && prod.bucPerSac > 0 ? prod.bucPerSac : 0;
                const qty = parseInt(val, 10);
                setEditForm(f => ({
                  ...f,
                  nrSaci: val,
                  nrBuc: bucPerSac > 0 && val !== '' && Number.isFinite(qty) && qty > 0 ? String(qty * bucPerSac) : f.nrBuc
                }));
              }} />
            </div>
            <div className="form-row">
              <label>Nr. Buc: <span className="field-optional">(opțional)</span></label>
              <input type="number" min="1" value={editForm.nrBuc} onChange={e=>setEditForm(f=>({...f,nrBuc:e.target.value}))} />
            </div>
            <div className="form-row times">
              <div>
                <label>Mecanic</label>
                <select value={editForm.mecanicId} onChange={e=>setEditForm(f=>({...f,mecanicId:e.target.value}))}>
                  <option value="">Fără mecanic</option>
                  {mecanici.map(m => <option key={`mec-${m.id}`} value={m.id}>{m.nume}</option>)}
                </select>
              </div>
              <div>
                <label>Operator</label>
                <select value={editForm.operatorId} onChange={e=>setEditForm(f=>({...f,operatorId:e.target.value}))}>
                  <option value="">Fără operator</option>
                  {operatori.map(op => <option key={`opE-${op.id}`} value={op.id}>{op.nume}</option>)}
                </select>
              </div>
            </div>
            <div className="form-section-header">Rebuturi</div>
            <div className="form-row">
              <label>Rebuturi General <span className="field-readonly-note">(calculat automat)</span></label>
              <input type="number" readOnly className="readonly-input"
                value={['rebuturiOperator','rebuturiCuptor','rebuturiMasinaSuflat','rebuturiReglaje','rebuturiSefTura','rebuturiPreforma'].reduce((s,k)=>s+(parseInt(editForm[k])||0),0)} />
            </div>
            <div className="form-row times">
              <div><label>Rebuturi Operator</label><input type="number" min="0" value={editForm.rebuturiOperator} onChange={e=>setEditForm(f=>({...f,rebuturiOperator:e.target.value}))} /></div>
              <div><label>Rebuturi Cuptor</label><input type="number" min="0" value={editForm.rebuturiCuptor} onChange={e=>setEditForm(f=>({...f,rebuturiCuptor:e.target.value}))} /></div>
            </div>
            <div className="form-row times">
              <div><label>Rebuturi Mașină Suflat</label><input type="number" min="0" value={editForm.rebuturiMasinaSuflat} onChange={e=>setEditForm(f=>({...f,rebuturiMasinaSuflat:e.target.value}))} /></div>
              <div><label>Rebuturi Reglaje</label><input type="number" min="0" value={editForm.rebuturiReglaje} onChange={e=>setEditForm(f=>({...f,rebuturiReglaje:e.target.value}))} /></div>
            </div>
            <div className="form-row times">
              <div><label>Rebuturi Śef Tură</label><input type="number" min="0" value={editForm.rebuturiSefTura} onChange={e=>setEditForm(f=>({...f,rebuturiSefTura:e.target.value}))} /></div>
              <div><label>Rebuturi Preformă</label><input type="number" min="0" value={editForm.rebuturiPreforma} onChange={e=>setEditForm(f=>({...f,rebuturiPreforma:e.target.value}))} /></div>
            </div>
            <div className="form-row">
              <label>Status:</label>
              <select value={editForm.status} onChange={e=>setEditForm(f=>({...f,status:e.target.value}))}>
                <option value="În desfășurare">În desfășurare</option>
                <option value="Finalizat">Finalizat</option>
              </select>
            </div>
            <div className="form-row times">
              <div><strong>Start:</strong> {selectedProd.dataStart || selectedProd.data_start}</div>
              <div><strong>Terminare:</strong> {selectedProd.dataTerminare || selectedProd.data_terminare}</div>
            </div>
            <div className="modal-actions">
              <button className="btn btn-delete" onClick={handleDelete}>Șterge</button>
              <button className="btn" onClick={handleSaveEdit}>Salvează</button>
              <button className="btn secondary" onClick={closeEdit}>Închide</button>
            </div>
          </div>
        </div>,
        document.body
      )}

      {selectedCreateSlot && ReactDOM.createPortal(
        <div className="edit-modal-overlay" onClick={closeCreateSlot}>
          <div className="edit-modal create-modal" onClick={(e)=>e.stopPropagation()}>
            <h3>Comandă de lucru nouă</h3>
            <div className="form-row times slot-readonly-grid">
              <div>
                <label>Stație</label>
                <div className="readonly-field">{selectedCreateSlot.statieName}</div>
              </div>
              <div>
                <label>Zi</label>
                <div className="readonly-field">{selectedCreateSlot.dateLabel}</div>
              </div>
            </div>
            <div className="form-row">
              <label>Produs</label>
              <select value={createForm.produsId} onChange={e => handleCreateFormChange('produsId', e.target.value)}>
                <option value="">Selectează produsul</option>
                {produse.map(prod => (
                  <option key={prod.id} value={prod.id}>{prod.denumire}</option>
                ))}
              </select>
            </div>
            <div className="form-row times">
              <div>
                <label>Preforma</label>
                <select value={createForm.preformaId} onChange={e => handleCreateFormChange('preformaId', e.target.value)}>
                  <option value="">Fără preformă</option>
                  {preforme.map(preforma => (
                    <option key={preforma.id} value={preforma.id}>{preforma.denumire}</option>
                  ))}
                </select>
              </div>
              <div>
                <label>Operator</label>
                <select value={createForm.operatorId} onChange={e => handleCreateFormChange('operatorId', e.target.value)}>
                  <option value="">Fără operator</option>
                  {operatori.map(operator => (
                    <option key={operator.id} value={operator.id}>{operator.nume}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="form-row times">
              <div>
                <label>Client</label>
                <select value={createForm.clientId} onChange={e => handleCreateFormChange('clientId', e.target.value)}>
                  <option value="">Generic automat</option>
                  {clienti.map(client => (
                    <option key={client.id} value={client.id}>{client.nume}</option>
                  ))}
                </select>
              </div>
              <div>
                <label>Nr. Saci <span className="field-optional">(opțional)</span></label>
                <input type="number" min="1" value={createForm.nrSaci} onChange={e => handleCreateFormChange('nrSaci', e.target.value)} placeholder="ex: 3" />
              </div>
            </div>
            <div className="form-row">
              <label>Nr. bucăți <span className="field-optional">(opțional)</span></label>
              <input type="number" min="1" value={createForm.nrBuc} onChange={e => handleCreateFormChange('nrBuc', e.target.value)} placeholder="se calculează automat din nr. saci" />
            </div>
            <div className="form-row times">
              <div>
                <label>Livrare</label>
                <input type="date" value={createForm.dataLivrare} onChange={e => handleCreateFormChange('dataLivrare', e.target.value)} />
              </div>
              <div>
                <label>Status</label>
                <select value={createForm.status} onChange={e => handleCreateFormChange('status', e.target.value)}>
                  <option value="În desfășurare">În desfășurare</option>
                  <option value="Finalizat">Finalizat</option>
                </select>
              </div>
            </div>
            <div className="form-row times">
              <div>
                <label>Ora start</label>
                <input type="time" value={createForm.startTime} onChange={e => handleCreateFormChange('startTime', e.target.value)} />
              </div>
              <div>
                <label>Ora terminare</label>
                <input type="time" value={createForm.endTime} onChange={e => handleCreateFormChange('endTime', e.target.value)} />
              </div>
            </div>
            <div className="form-row">
              <label>Observații</label>
              <textarea value={createForm.observatii} onChange={e => handleCreateFormChange('observatii', e.target.value)} rows="3" />
            </div>
            <div className="modal-actions">
              <button className="btn" onClick={handleSaveCreate} disabled={loading}>Salvează</button>
              <button className="btn secondary" onClick={closeCreateSlot}>Închide</button>
            </div>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
};

export default CalendarProductie;
